import { render, staticRenderFns } from "./R8.vue?vue&type=template&id=23163792"
import script from "./R8.vue?vue&type=script&lang=js"
export * from "./R8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports